<template>
    <div :class="event && event.experiencia ? 'single-event' : ''" v-if="! loading">
        <CuentaAtras @tiempoTerminado="tiempoTerminado = true"/>
        <PageTitle 
            title="" 
            :style="'background-image: url(&quot;' + event.imagen + '&quot;);'"
        />
        <template v-if="event">
            <CabeceraClubs
                v-if="event.equipo_local"
                :event="event"
            />

            <CabeceraImagen
                v-if="! event.equipo_local"
                :event="event"
            />

            <template v-if="event.status == 3">
                <section class="padding-vertical-content">
                    <div class="container">
                        <div class="row align-items-center" style="height: 300px">
                            <div class="col-12 align-items-center">
                                <h1 class="text-center">{{ $t('partido.aplazado') }}</h1>
                            </div>                            
                        </div>
                    </div>
                </section>
            </template>
            <template v-else-if="event.venta_cerrada">
                <section class="padding-vertical-content">
                    <div class="container">
                        <div class="row align-items-center" style="height: 300px">
                            <div class="col-12 align-items-center">
                                <h1 class="text-center">{{ $t('partido.venta_cerrada') }}</h1>
                            </div>                            
                        </div>
                    </div>
                </section>
            </template>
            <template v-else>
                <template v-if="$route.name == 'front.eventos.show.abonados' && event">
                    <template v-if="event.lfp_id == null">
                        <ProcesoCompraAbonado
                            v-if="refresh"
                            :tiempoTerminado="tiempoTerminado"
                            :event="event"
                            :sesion_id="sesion_id"
                            @reset="recargar"
                        />
                    </template>
                    <template v-else>
                        <ProcesoCompraAbonadoLfp :evento="event" :sesion_id="sesion_id" />
                    </template>
                </template>

                <template v-else-if="$route.name == 'front.eventos.show.amigosabonados'">
                    <ProcesoCompraAmigoAbonado
                        v-if="event"
                        :tiempoTerminado="tiempoTerminado"
                        :event="event"
                        :sesion_id="sesion_id"
                        @reset="recargar"
                    />
                </template>

                <template v-else>
                    <ProcesoCompraConRecinto
                        v-if="event && event.tiene_recinto && refresh && teatro.sga == false"
                        :tiempoTerminado="tiempoTerminado"
                        :event="event"
                        :sesion_id="sesion_id"
                        @reset="recargar"
                    />

                    <ProcesoCompraEventoSga 
                        v-if="teatro.sga"
                        :event="event"
                        :sesion_id = "sesion_id"
                    />

                    <ProcesoCompraSinRecinto
                        v-if="event && !event.tiene_recinto && refresh && teatro.sga == false"
                        :tiempoTerminado="tiempoTerminado"
                        :event="event"
                        :sesion_id="sesion_id"
                        @reset="recargar"
                    />
                </template>    
            </template>                
        </template>
        <template v-else>
            <section class="padding-vertical-content">
                <div class="container">
                    <div class="row">
                        <div class="col-12 text-center" style="height: 600px">
                            <LoaderComponent/>
                        </div>
                    </div>
                </div>
            </section>
        </template>
        
    </div>
    <div v-else>
        <div class="card-body">
            <LoaderComponent/>
        </div>
    </div>
</template>

<script>
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import CuentaAtras from '@/components/frontend/events/compra/CuentaAtras';
    import ProcesoCompraSinRecinto from '@/components/frontend/events/compra/ProcesoCompraSinRecinto';
    import ProcesoCompraConRecinto from '@/components/frontend/events/compra/ProcesoCompraConRecinto';
    import ProcesoCompraAbonado from '@/components/frontend/events/compra/DiaAbonado/ProcesoCompraAbonado';
    import ProcesoCompraAmigoAbonado from '@/components/frontend/events/compra/ProcesoCompraAmigoAbonado';
    import ProcesoCompraAbonadoLfp from '@/components/frontend/events/compra/ProcesoCompraAbonadoLfp';
    import CabeceraClubs from '@/components/frontend/events/show/CabeceraClubs';
    import CabeceraImagen from '@/components/frontend/events/show/CabeceraImagen';
    import ProcesoCompraEventoSga from '@/components/frontend/events/compra/sga/ProcesoCompraEventoSga';
    import { useHead } from '@/composables/common/seo/useHead';

    export default {
        props: ['event_id', 'sesion_id', 'event'],
        data() {
            return {
                zonas: null,
                datos: {},
                formulario: null,
                session_id: null,
                terminos: false,
                newsletter: false,
                paso2: false,
                paso3: false,
                entradas: null,
                loading: false,
                tiempoTerminado: false,
                refresh: true
            }
        },
        created() {
            useHead(this.event?.name || 'Evento');
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            mostrar_header() {
                if(this.$route.name == 'front.home') {
                    return false;
                }
                if(this.$route.name == 'login') {
                    return false;
                }

                return true;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
        },
        methods: {
            recargar(){
                return new Promise(() => {
                    this.refresh = false;
                    this.$nextTick(() => {
                        this.refresh = true;
                    })
                    this.tiempoTerminado = false;
                })
            }
        },
        components: {
            PageTitle, CuentaAtras, ProcesoCompraSinRecinto, ProcesoCompraConRecinto, ProcesoCompraAbonado, ProcesoCompraAmigoAbonado, ProcesoCompraAbonadoLfp,
            CabeceraClubs, CabeceraImagen, ProcesoCompraEventoSga
        }
    }
</script>

<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>
